var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoGoogle = function SvgLogoGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 62 62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M47.074 31.358c0-1.322-.11-2.287-.346-3.287h-15.4v5.965h9.04c-.183 1.483-1.167 3.715-3.354 5.216l-.03.2 4.869 3.696.337.033c3.098-2.804 4.884-6.93 4.884-11.823"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M31.328 47.074c4.429 0 8.147-1.43 10.862-3.894l-5.176-3.93c-1.385.947-3.244 1.608-5.686 1.608a9.86 9.86 0 0 1-9.33-6.68l-.193.017-5.063 3.84-.066.18c2.697 5.25 8.237 8.859 14.652 8.859"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M21.997 34.179a9.7 9.7 0 0 1-.547-3.18c0-1.107.2-2.178.529-3.178l-.01-.213-5.126-3.902-.168.078A15.8 15.8 0 0 0 14.925 31c0 2.59.639 5.036 1.75 7.215z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M31.328 21.141c3.08 0 5.158 1.304 6.342 2.393l4.63-4.429c-2.843-2.59-6.543-4.18-10.972-4.18-6.415 0-11.955 3.608-14.652 8.86l5.303 4.036c1.33-3.876 5.012-6.68 9.35-6.68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D7DE",
    strokeOpacity: 0.5,
    d: "M31 .5c16.833 0 30.5 13.656 30.5 30.474v.052C61.5 47.844 47.833 61.5 31 61.5S.5 47.844.5 31.026v-.052C.5 14.156 14.167.5 31 .5Z"
  })));
};
export default SvgLogoGoogle;